import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EvsErr} from '../evsErr';
import {EvsStampService} from '../../../../common/services/EvsStamp.service';

import {IOption} from 'ng-select';
import {EvsProductService} from '../../../../common/services/EvsProduct.service';
import {BatchstampService} from '../../qrcode/batchstamp/batchstamp.service';
import {EvsAddressService} from '../../../../common/services/EvsAddress.service';

declare var $: any;

@Component({
    selector: 'evs-stamp-distribution',
    templateUrl: 'stamp-distribution.template.html',
    styleUrls: ['style.css'] ,
    providers: [EvsStampService,EvsProductService, BatchstampService, EvsAddressService]
})

export class StampDistributionComponent implements OnInit {
    title:string = 'Kích hoạt phân phối tem';
    public message:any = {class:'alert-success', content:''};
    public activateStampForm: FormGroup;

    public list_product:Array<IOption> = [];
    // public list_order:any = [];
    public list_order:Array<IOption> = [];
    public action:string = 'active';
    status_active:string = 'active';
    btn_disable = false;

    public type_active:any = 'batch';

    public order_value:any='';
    public start_value:any;
    public end_value:any;
    public list_value:any;
    order_name = '';
    total_stamp = 0;
    total_active = 0;
    list_store:Array<IOption> = [];
    list_city:Array<IOption> = [];
    list_district:Array<IOption> = [];
    public store_id:number = 0;
    public store_selected:any = {};
    to_address_value:any = '';
    selected_city:boolean = false;


    constructor(private stampService: EvsStampService,
                private _fb: FormBuilder,
                private batchService: BatchstampService,
                private addressService: EvsAddressService) {

    }


    ngOnInit(){

        //get list order
        this.getListOrder();

        //
        this.getListCity();

        this.getListStore();

        // this.checkShowHiddenBlockInput(this.typeActive);
        this.createForm();


        $('#stamp-active-date-exp').datepicker({
            // format: 'mm/dd/yyyy',
            // "setDate": new Date(),
        });
    }

    getListCity(){
        this.addressService.getCities().toPromise().then((res:any)=>{
            if(res.statusCode){
                let cities = [];
                for (let c of res.data.cities){
                    cities.push({value:c.city_name, label: c.city_name, id:c.id})
                }
                this.list_city = cities;
            }
        });
    }

    getListDistrict(event){
        let city_id = event.id;
        this.selected_city = true;
        this.addressService.getDistrict({city_id:city_id}).toPromise().then((res:any)=>{
            if(res.statusCode){
                let districts = [];
                for (let d of res.data.districts){
                    districts.push({value:d.district_name, label: d.district_name, id:d.id})
                }
                this.list_district = districts;
            }
        });
    }

    getListStore(){
        this.stampService.getAllStore({desc:'id', status:1, limit:500, deleted:0}).toPromise().then((res:any)=>{
            if(res.status == 200){
                let all_store = [];
                for(let p of res.data.store){
                    all_store.push({value:p.id, label:p.name});
                }
                this.list_store = all_store;
            }else if(res.status==400) {
                this.message.class='warning';
                this.message.content=res.message;
            }else {
                EvsErr.evs_err(res,false);
            }
        }).catch((err:any)=>{
            EvsErr.evs_err(err);
        });
    }
    selectStore(ele){
        this.store_id = ele.value;
        this.stampService.getStore(ele.value).toPromise().then((res:any)=>{
            if(res.status == 200){
                this.store_selected = res.data;
                this.to_address_value = res.data.address;
            }else if(res.status==400) {
                this.message.class='warning';
                this.message.content=res.message;
            }else {
                EvsErr.evs_err(res,false);
            }
        }).catch((err:any)=>{
            EvsErr.evs_err(err);
        });
    }
    deselectStore(ele){
        this.store_id = 0;
        this.to_address_value = '';
    }

    getListOrder(){
        this.stampService.listOrder({status:3, is_deleted:0, limit:500, service:4, desc:'id'}).toPromise().then((res:any) => {
            // console.log('order',res);
            if(res.error == false){
                let listO = [];
                for(let item of res.data.orders){
                    let obj = {
                        'value' : item.id,
                        'label' : item.name,
                    };
                    listO.push(obj);
                }
                this.list_order = listO;
            }else {
                EvsErr.evs_err(res,false);
            }
        }).catch((err:any)=>{
            EvsErr.evs_err(err);
        });
    }

    createForm() {

        this.activateStampForm = this._fb.group({
            select_type_active: [null],
            order_id: [null, [Validators.required]],
            start: [null],
            end: [null],
            list: [null],

            store_id: [null],
            to_city: [null],
            to_district: [null],
            to_address: [null],

            // sku: [null, [Validators.required]],
            // status: '1',
            // description: [''],

        });
    }
    onSubmit(data:any){
        this.btn_disable = true;
        let request:any = {} ;
        if(data.store_id > 0){
            request.store_id = data.store_id;
            if(this.store_selected.province){
                request.to_city = this.store_selected.province;
            }
            if(this.store_selected.district){
                request.to_district = this.store_selected.district;
            }
            if(this.store_selected.address){
                request.to_address = this.store_selected.address;
            }
        }else {
            if(data.to_city){
                request.to_city = data.to_city;
            }
            if(data.to_district){
                request.to_district = data.to_district;
            }
            if(data.to_address){
                request.to_address = data.to_address;
            }
        }


        if(data.select_type_active == 'batch'){
            if(data.start && data.end){
                request.start = this.serialToNumber(data.start);
                request.end = this.serialToNumber(data.end);
                this.total_stamp = request.end - request.start + 1;
            }
        }else{ // list
            if(data.list){
                let arr_list = data.list.split(',');
                this.total_stamp = arr_list.length;
                let list = [];
                for (let item of arr_list){
                    list.push(this.serialToNumber(item));
                }
                request.list = list;
            }
        }
        request.order_id = data.order_id;
        request.typeUpdate = 1; // 0: kich hoat, 1: phân phối



        // console.log('data',data);
        // console.log('request',request);

        $('#stamp-active-message').hide(100);
        this.stampService.changeStampStatus(request,this.status_active).toPromise().then((res:any) => {
            this.btn_disable = false;
            if(res.error == false){
                this.total_active = res.data.nModified;
                $("#activeSuccessAlert").modal();
                this.message.class='success';
                // this.message.content='Thông tin kích hoạt phân phối!';
                this.message.content='Yêu cầu kích hoạt tem đang được thực hiện!';
                $('#stamp-active-message').show(200);
            }else {
                this.message.class='warning';
                this.message.content='Kích hoạt phân phối chưa thành công. Vui lòng thử lại';
                $('#stamp-active-message').show(200);

                EvsErr.evs_err(res,false);
                let body = $("html, body");
                body.stop().animate({scrollTop:0}, 500, 'swing', function() {});
            }
        }).catch((err:any)=>{
            this.btn_disable = false;
            this.message.class="warning";
            this.message.content='Kích hoạt phân phối chưa thành công. Vui lòng thử lại';
            EvsErr.evs_err(err,false);
            let body = $("html, body");
            body.stop().animate({scrollTop:0}, 500, 'swing', function() {});
        });
    }

    select_order(event){
        let order_id = event.value;
        // batchService
        this.batchService.getDetailsOrder(order_id).subscribe(
            res => {
                if (res.status == 200) {
                    this.order_name = res.data.name;
                    this.start_value = this.formatSerial(res.data.id_start, res.data.prefix);
                    this.end_value = this.formatSerial(res.data.id_end, res.data.prefix);
                }else if(res.status == 400){
                    this.message.class="warning";
                    this.message.content=res.status;
                    let body = $("html, body");
                    body.stop().animate({scrollTop:0}, 500, 'swing', function() {});
                }
            });
    }

    formatSerial(serial, prefix:string = ''){
        let format_serial:string;
        let prefix2 = prefix ? prefix+'-' : '';
        serial = serial.toString();
        if(serial.length > 6){
            format_serial = prefix2+serial;
        }else {
            let pad = "000000";
            format_serial = prefix2 + pad.substring(0, 6 - serial.length) + serial;
        }

        return format_serial;
    }
    serialToNumber(serial){
        let _serial = serial.split('-');
        if(_serial.length==1){
            return parseInt(_serial[0]);
        }else {
            return parseInt(_serial[1]);
        }
    }



    empty(data)
    {
        if(typeof(data) == 'number' || typeof(data) == 'boolean')
        {
            return false;
        }
        if(typeof(data) == 'undefined' || data === null)
        {
            return true;
        }
        if(typeof(data.length) != 'undefined')
        {
            return data.length == 0;
        }
        let count = 0;
        for(let i in data)
        {
            if(data.hasOwnProperty(i))
            {
                count ++;
            }
        }
        return count == 0;
    }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp/stamp-distribution.component.ts